var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navbar-window",
      style: {
        top: _vm.top,
        right: _vm.right,
        bottom: _vm.bottom,
        left: _vm.left
      },
      attrs: { id: "navbar-user-window" }
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticStyle: { height: "50px", position: "relative" } },
            [
              _c("loading-spinner", {
                attrs: {
                  active: _vm.loading,
                  "is-full-page": false,
                  color: "#4fa2b7",
                  height: 25
                },
                on: {
                  "update:active": function($event) {
                    _vm.loading = $event
                  }
                }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "options-container" },
            [
              _c(
                "a",
                {
                  staticClass: "options",
                  attrs: { href: "/settings/profile" }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("Settings")) + "\n    ")]
              ),
              _vm._v(" "),
              _vm.settingsOpen
                ? _c("settings-menu", {
                    attrs: {
                      "two-factor-authentication-pop-up":
                        _vm.twoFactorAuthenticationPopUp
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.settingsOpen && !_vm.companyButtonDisable
                ? _c(
                    "div",
                    {
                      staticClass: "options",
                      on: { click: _vm.changeCompany }
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.$t("SwitchCompany")) + "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.settingsOpen
                ? _c(
                    "div",
                    { staticClass: "options", on: { click: _vm.goToWiki } },
                    [_vm._v("\n      " + _vm._s(_vm.$t("Wiki")) + "\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.settingsOpen
                ? _c(
                    "div",
                    { staticClass: "options", on: { click: _vm.showLicenses } },
                    [_vm._v("\n      " + _vm._s(_vm.$t("About")) + "\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.settingsOpen
                ? _c("hr", { attrs: { id: "userHR" } })
                : _vm._e(),
              _vm._v(" "),
              !_vm.settingsOpen
                ? _c(
                    "div",
                    {
                      staticClass: "options logout-text",
                      on: { click: _vm.logout }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.$t("Logout")) + "\n    ")]
                  )
                : _vm._e()
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4a5e898", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4a5e898","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Navbar/UserWindow/UserWindow.vue
// module id = null
// module chunks = 